var _rect, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlendLogo = function SvgBlendLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#F66761"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.8698 23.4256L35.8021 16.7982C34.8543 19.5709 34.7866 20.6529 30.7923 20.6529C27.5427 20.6529 25.5793 20.1119 24.4961 18.4889C23.3452 20.1795 22.3974 20.7205 18.1323 20.7205C14.7473 20.7205 14.9504 19.9766 13.8672 18.4212L14.0026 33.0962H14.0703C14.138 37.7625 17.9292 39.4531 25.0377 39.4531C32.214 39.3855 35.9375 37.6948 35.9375 33.0286V32.961L35.8698 23.4256Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3045 11.5234C16.3045 14.3638 16.7107 15.6487 19.6218 15.6487C22.5329 15.6487 22.8714 14.2961 22.8714 11.5234H16.3045Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7303 11.5234C26.7303 14.3638 27.1365 15.6487 30.0476 15.6487C32.9587 15.6487 33.3649 14.2961 33.2972 11.5234H26.7303Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlendLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blendLogo.937d8d21.svg";
export { ForwardRef as ReactComponent };